import { useState } from "react";
import Input from "../../design/Input";
import { BiEditAlt } from "react-icons/bi";
import { MdDelete } from "react-icons/md";
import { IoIosSend } from "react-icons/io";
import regx from "../../../functions/regx";


function ContinerTrWorkers({data, keyCon, keyName, setMassage, id_office}) {
    const [edit, setEdit] = useState(true);

    const [dataWorker, setDataWorker] = useState({
        name: data["name"], email: data["email"], phone: data["phone"], user: data["user"]
    });

    const resolveFromServer = (resolve) => {
        if (typeof resolve === 'object' && resolve !== null && resolve[0] === 'okay' && resolve['data']) {
            setMassage({text: resolve['data'], open: true});
        } else {
            setMassage({text: "שגיאה", open: true});
        }
    }

    const clickSend = () => {
        if (regx('strEnHe', dataWorker.name, false) && regx('email', dataWorker.email, false) && regx('phone', dataWorker.phone, false) 
            && regx('passpord', dataWorker.user, false)) {
        setMassage({text: "", data: {...dataWorker, num: keyCon, office: id_office}, url: "adminUsers/save-worker", open: true, fun: resolveFromServer});
        }
    }

    const clickDelete = () => {
        setMassage({text: "", data: {num: keyName}, url: "adminUsers/delete-worker", open: true, fun: resolveFromServer});  
    }

    return (
    <tr key={keyCon}>
        <td key={0}> {keyCon + 1} </td>

        <td key={1}> 
            <Input 
                value={dataWorker.name}
                onChange={(v) => setDataWorker({...dataWorker, name: v})}
                disable={edit}
                direction={'ltr'}
                pattern={'strEnHe'}
            />
        </td>

        <td key={2}>
            <Input
            value={dataWorker.email}
            onChange={(v) => setDataWorker({...dataWorker, email: v})}
            disable={edit}
            direction={'ltr'}
            pattern={'email'}
            />
        </td>

        <td key={3}>
            <Input
            value={dataWorker.phone}
            onChange={(v) => setDataWorker({...dataWorker, phone: v})}
            disable={edit}
            direction={'ltr'}
            pattern={'phone'}
            />
        </td>

        <td key={4}>
            <Input
            value={dataWorker.user}
            onChange={(v) => setDataWorker({...dataWorker, user: v})}
            disable={edit}
            direction={'ltr'}
            pattern={'passpord'}
            />
        </td>

        <td key={5} onClick={() => setEdit(false)}>
            <BiEditAlt color="gray" />
        </td>

        <td key={6} onClick={clickDelete}>
            <MdDelete color="red" />
        </td>

        <td key={7} onClick={clickSend}>
            <IoIosSend color="blue" />
        </td>
    </tr>
    )
}


export default ContinerTrWorkers;